module.exports = __webpack_public_path__ + "static/media/52608893_2452969954778181_4556521656046059520_o.1a6cd241.jpg";